KM3D.scenes.hidrolik = function (T, M, KM) {
  var P = Math.PI, root = new T.Group(), NP = 9, RHO = 0.66, BETA = 0.36, X0 = -0.55, ROD = 1.5;
  function add(m, x, y, z, p) { m.position.set(x, y, z); (p || root).add(m); return m; }
  var shaft = new T.Group(); root.add(shaft);
  add(KM.cylX(T, 0.36, 0.36, 2.3, M.steel, 28), -2.15, 0, 0, shaft);
  var spl = new T.Mesh(KM.gear(T, { n: 10, ro: 0.4, ri: 0.32, d: 0.9 }), M.chrome); spl.rotation.y = P / 2; add(spl, -3.0, 0, 0, shaft);
  add(KM.cylX(T, 0.5, 0.5, 0.5, M.chrome, 32), -1.3, 0, 0, shaft);
  var bear = new T.Group(); root.add(bear);
  add(KM.cylX(T, 0.82, 0.82, 0.42, M.chrome, 40), -1.55, 0, 0, bear);
  var br = new T.Mesh(new T.TorusGeometry(0.66, 0.05, 10, 40), M.steel); br.rotation.y = P / 2; add(br, -1.34, 0, 0, bear);
  var sw = new T.Group(); sw.position.x = X0; sw.rotation.z = -BETA; root.add(sw);
  add(KM.cylX(T, 1.18, 1.18, 0.16, M.dark, 56), 0, 0, 0, sw);
  add(KM.cylX(T, 0.95, 0.95, 0.06, M.steel, 56), 0.1, 0, 0, sw);
  var wedge = new T.Mesh(new T.BoxGeometry(0.5, 2.2, 1.0), M.dark); wedge.position.set(-0.32, 0.1, 0); sw.add(wedge);
  var barrel = new T.Group(); root.add(barrel);
  var bore = new T.CylinderGeometry(0.24, 0.24, 1.8, 24, 1, true); bore.rotateZ(P / 2);
  var bmat = new T.MeshPhysicalMaterial({ color: 0xcfd8e0, metalness: 0.2, roughness: 0.08, transparent: true, opacity: 0.32, side: T.DoubleSide, depthWrite: false });
  var rodG = new T.CylinderGeometry(0.13, 0.13, ROD, 16); rodG.rotateZ(P / 2);
  var headG = new T.CylinderGeometry(0.22, 0.22, 0.22, 20); headG.rotateZ(P / 2);
  var slipG = new T.CylinderGeometry(0.26, 0.26, 0.07, 22); slipG.rotateZ(P / 2);
  var ballG = new T.SphereGeometry(0.17, 14, 10);
  var oilG = new T.CylinderGeometry(0.215, 0.215, 1, 20); oilG.rotateZ(P / 2);
  var pis = [], i;
  for (i = 0; i < NP; i++) {
    var a = i / NP * P * 2, g = new T.Group(); g.userData.a = a; g.rotation.x = a; barrel.add(g);
    var bo = new T.Mesh(bore, bmat); bo.position.set(0.55 + 0.9 - 0.1 + 0.1, RHO, 0); bo.position.x = 0.3 + 0.9 + 0.0; g.add(bo);
    var pg = new T.Group(); g.add(pg);
    var rd = new T.Mesh(rodG, M.steel); rd.position.x = ROD / 2; pg.add(rd);
    var hd = new T.Mesh(headG, M.chrome); hd.position.x = ROD; pg.add(hd);
    var sl = new T.Mesh(slipG, M.brass); sl.position.x = -0.02; pg.add(sl);
    var bl = new T.Mesh(ballG, M.brass); bl.position.x = 0.05; bl.scale.set(0.7, 1, 1); pg.add(bl);
    var oil = new T.Mesh(oilG, M.oil); g.add(oil);
    g.userData.pg = pg; g.userData.oil = oil; pis.push(g);
  }
  var plate = KM.cylX(T, 1.2, 1.2, 0.08, M.brass, 56); add(plate, 2.25, 0, 0, barrel);
  var plate2 = KM.cylX(T, 0.95, 0.95, 0.1, M.brass, 56); add(plate2, 0.2, 0, 0, barrel);
  var cap = KM.cylX(T, 0.34, 0.34, 0.25, M.chrome, 24); add(cap, 2.38, 0, 0, barrel);
  var spr = KM.spring(T, 0.3, 1.9, 9, 0.03, M.steel); spr.rotation.z = -P / 2; add(spr, 0.3, 0, 0, barrel);
  var sp2 = KM.spring(T, 0.22, 3.0, 12, 0.04, M.steel); sp2.rotation.z = -P / 2; add(sp2, -1.3, 2.25, 0);
  add(KM.cylX(T, 0.17, 0.17, 0.5, M.brass, 14), -1.5, 2.25, 0); add(KM.cylX(T, 0.3, 0.3, 0.5, M.chrome, 20), 2.0, 2.25, 0);
  add(KM.shadow(T, 9, 4, -1.55, 0.7), -0.2, -1.55, 0);
  function update(t) {
    var ph = t * 2.2;
    barrel.rotation.x = ph; shaft.rotation.x = ph;
    for (var i = 0; i < NP; i++) {
      var g = pis[i], ang = g.userData.a + ph;
      var xs = X0 + Math.tan(BETA) * RHO * Math.cos(ang) * 0 - Math.tan(BETA) * RHO * Math.cos(ang);
      var pg = g.userData.pg; pg.position.set(xs + 0.08, RHO, 0);
      var oil = g.userData.oil, hx = xs + 0.08 + ROD + 0.1, end = 2.15, L = Math.max(0.05, end - hx);
      oil.scale.x = L; oil.position.set(hx + L / 2, RHO, 0);
    }
  }
  root.position.set(-0.3, 0, 0);
  return { root: root, update: update, pose: 0.6, cam: { fov: 30, p: [4.6, 3.2, 9.4], l: [0.4, 0.6, 0] } };
};